import { Injectable, OnDestroy, isDevMode } from '@angular/core'
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

type subjectCallback = (data: string) => void;

@Injectable()
export class NatsService implements OnDestroy {
    private nats: any;
    private natsServerAddr: string;
    private taskID: string;
    private natsService: any;
    progressMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('Parsing...');
    resultLink$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    constructor() {
        this.nats = require('websocket-nats');
        if (isDevMode()) {
            this.natsServerAddr = 'ws://localhost:4223';
        } else {
            this.natsServerAddr = 'wss://ws.dataflowkit.com';
        }
    }

    publish(subject: string, data: string) {
        this.nats.publish(subject, data);
    }

    subscribe(subject: string, callback: subjectCallback) {
        this.nats.subscribe(subject, callback);
    }

    request(subject: string, data: string, callback: subjectCallback) {
        this.nats.request(subject, data, {'max': 1}, callback);
    }

    parse(payload: string): Observable<any> {
        return Observable.create(observer => {
            this.natsService = this.nats.connect(this.natsServerAddr);
            this.natsService.on('connect', () => {
                this.natsService.request('parse', payload, null, (id) => {
                    this.taskID = id;
                    let response_sid = this.natsService.subscribe('task_' + this.taskID, (parse_res) => {
                        observer.next(parse_res);
                    });

                    let error_sid = this.natsService.subscribe('task_' + this.taskID + '_error', (err) => {
                        this.natsService.unsubscribe(response_sid);
                        this.natsService.unsubscribe(error_sid);
                        this.natsService.unsubscribe(complete_sid);
                        this.natsService.unsubscribe(info_sid);
                        this.natsService.close();
                        observer.error(err);
                    });

                    let complete_sid = this.natsService.subscribe('task_' + this.taskID + '_finished', (parseResult) => {
                        console.log('Recieved complete message');
                        this.natsService.unsubscribe(response_sid);
                        this.natsService.unsubscribe(error_sid);
                        this.natsService.unsubscribe(complete_sid);
                        this.natsService.unsubscribe(info_sid);
                        this.natsService.close();
                        this.resultLink$.next(parseResult);
                        observer.complete();
                    });

                    let info_sid = this.natsService.subscribe('task_' + this.taskID + '_info', (info) => {
                        this.SetProgressMessage(info);
                    });

                    this.natsService.publish(id, 'I got it');
                    this.SetProgressMessage('Processing...');
                });
            });
            this.natsService.on('error', (err) => {
                observer.error('NATS server connection failed.');
            });
        });
    }

    SetProgressMessage(message: string) {
        this.progressMessage$.next(message);
    }

    cancel() {
        this.natsService.publish('cancel_' + this.taskID, 'Cancel');
        this.SetProgressMessage('Canceling...');
    }

    ngOnDestroy() {
        /* this.nats.close(); */
    }
}
